import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { SocketProvider } from './hooks/useSocket';
import HomePage from './pages/Home';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import WorkoutPage from './pages/Workout';
import HistoryPage from './pages/History';
import ProfilePage from './pages/Profile';
import AiPlanPage from './pages/AiPlan';
import WorkoutsManagePage from './pages/WorkoutsManage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <SocketProvider>
          <Layout>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="/workout" element={<ProtectedRoute><WorkoutPage /></ProtectedRoute>} />
              <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/plan" element={<ProtectedRoute><AiPlanPage /></ProtectedRoute>} />
              <Route path="/workouts-manage" element={<ProtectedRoute><WorkoutsManagePage /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </SocketProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
